import { useState, useCallback, useEffect } from "react";
import { useRouter } from "next/router";

import { getStripe } from "lib/stripe/client";
import { useGetLoginStatus, useGetUser } from "lib/auth";

const DEFAULT_COUPON = process.env.NEXT_PUBLIC_STRIPE_DEFAULT_COUPON;

const useHandleCheckout = () => {
  useEffect(() => {
    getStripe();
  }, []);

  const router = useRouter();
  const [priceIdLoading, setPriceIdLoading] = useState<string | null>(null);

  const loggedIn = useGetLoginStatus();
  const user = useGetUser();

  const email = user?.email;

  const handleCheckout = useCallback(
    async (priceId: string) => {
      setPriceIdLoading(priceId);
      if (!loggedIn) {
        return router.push(`/signup?next=${router.asPath}&plan=${priceId}`);
      }
      // if (subscription) {
      //   return router.push("/account");
      // }

      try {
        const resp = await fetch("/api/create-checkout-session", {
          method: "POST",
          body: JSON.stringify({
            price: priceId,
            coupon: DEFAULT_COUPON,
            email,
          }),
          headers: new Headers({ "Content-Type": "application/json" }),
        });
        const data = await resp.json();
        const { sessionId } = data;
        const stripe = await getStripe();
        stripe.redirectToCheckout({ sessionId });
      } catch (error) {
        console.log(error.message);
      } finally {
        setPriceIdLoading(null);
      }
    },
    [router, email, loggedIn]
  );

  return [handleCheckout, priceIdLoading] as const;
};

export default useHandleCheckout;
